import { gql } from '@apollo/client'

export const BULK_DELETE_MEMBERS = gql`
  mutation DeleteTestSessionMembers($ids: [ID!]!, $testSessionId: ID!, $removeAll: Boolean) {
    deleteTestSessionMembers(ids: $ids, testSessionId: $testSessionId, removeAll: $removeAll)
  }
`
